const TITLE_RE = /^(Mr|Mrs|Ms|Miss|Dr)\.?(\s|$)/i;

/**
 * Build a single display name without duplicating Mr/Ms when APIs send
 * title separately and also embed it in first_name or employee_name.
 */
export function formatEmployeeDisplayName(details) {
    if (!details || typeof details !== "object") return "";

    const title = String(details.title ?? "").trim();
    const first = String(details.first_name ?? "").trim();
    const last = String(details.last_name ?? "").trim();
    const employeeName = String(
        details.employee_name ?? details.full_name ?? details.display_name ?? "",
    ).trim();

    if (employeeName && (first === employeeName || (!first && !last))) {
        return dedupeLeadingTitle(employeeName);
    }

    let useTitle = title;
    if (useTitle && first) {
        const t = useTitle.toLowerCase();
        const f = first.toLowerCase();
        if (f === t || f.startsWith(`${t} `)) {
            useTitle = "";
        }
    }

    if (!first && !last && employeeName) {
        return dedupeLeadingTitle(employeeName);
    }

    const composed = [useTitle, first, last].filter(Boolean).join(" ").trim();
    return dedupeLeadingTitle(composed || employeeName);
}

export function dedupeLeadingTitle(name) {
    if (!name) return "";
    let out = name.trim();
    out = out.replace(/^((Mr|Mrs|Ms|Miss|Dr)\.?\s+)(?:Mr|Mrs|Ms|Miss|Dr)\.?\s+/i, "$1");
    return out;
}

/** True when first_name already includes a salutation prefix. */
export function firstNameIncludesTitle(firstName, title) {
    const first = String(firstName ?? "").trim();
    const t = String(title ?? "").trim();
    if (!first) return false;
    if (TITLE_RE.test(first)) return true;
    if (t && first.toLowerCase().startsWith(`${t.toLowerCase()} `)) return true;
    return false;
}
